import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteOffer } from "./deleteSpecialOffer.request";
import { DeleteOfferResponse } from "./deleteSpecialOffer.types";

const useDeleteSpecialOffer = (
  options?: MutationOptions<DeleteOfferResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteOffer,
    ...options
  });
};

export default useDeleteSpecialOffer;
